<router-outlet></router-outlet>
@defer {
    <vex-pwa-install></vex-pwa-install>
}
